// Register all components for CMS

/*
  Company Admin
 */
const ActiveVisitors = () => import("@/components/cms/companyAdmin/visitors-list/active-visitors");
const AdminDepartments = () => import("@/components/cms/companyAdmin/departments/departments");
const AdminDepartmentsEdit = () => import("@/components/cms/companyAdmin/departments/departments-edit");
const JobDepartments = () => import("@/components/cms/companyAdmin/jobDepartments/job-departments");
const CompanyUsers = () => import("@/components/cms/companyAdmin/Employees/users");
const CompanyUsersEdit = () => import("@/components/cms/companyAdmin/Employees/users-edit");
const DropinUsers = () => import("@/components/cms/companyAdmin/Dropin/users");
const DropinUsersEdit = () => import("@/components/cms/companyAdmin/Dropin/users-edit");
const CompanyMessages = () => import("@/components/cms/companyAdmin/messages/employersMessages/employee-messages");
const DropinMessages = () => import("@/components/cms/companyAdmin/messages/dropinMessages/messages");
const VisitorMessages = () => import("@/components/cms/companyAdmin/messages/visitorMessages/messages");
const EvacuationMessages = () => import("@/components/cms/companyAdmin/messages/evacuationMessages/evacuation-messages");
const VisitexpressMessages = () => import("@/components/cms/companyAdmin/messages/visitexpressMessages/visitexpress-messages");
const PreregistrationMessages = () => import("@/components/cms/companyAdmin/messages/preregistrationMessages/preregistration-messages");
const MultiQueue = () => import("@/components/cms/companyAdmin/multiQueue/multiQueue");
const CompanySettings = () => import("@/components/cms/companyAdmin/settings/companySettings");
/*
  Common
 */
const Statistics = () => import("@/components/cms/common/statistics/statistics");
const SiteSettings = () => import("@/components/cms/common/settings/Sites/sitesSettings");
const Versions = () => import("@/components/cms/common/settings/versions");
const Tokens = () => import("@/components/cms/common/settings/tokens");
const LoginPictureSettings = () => import("@/components/cms/common/settings/loginPictureSettings");
const DashboardSlideshowSettings = () => import("@/components/cms/common/settings/dashboardSlideshowSettings");
const LangDictionary = () => import("@/components/cms/common/settings/langDictionary");
const LangDictionaryEdit = () => import("@/components/cms/common/settings/langDictionaryEdit");

/*
  Web Constructor
 */
const Editor = () => import("@/components/cms/webConstructor/sitePageEditor/editor");

/*
  InfoSearch
*/
const InfoSearchBase = () => import("@/components/cms/infosearch/infoSearchBase");
const InfoSearchSites = () => import("@/components/cms/infosearch/sites/sites");
const InfoSearchAreas = () => import("@/components/cms/infosearch/areas/areas");
const InfoSearchAreasEdit = () => import("@/components/cms/infosearch/areas/areas-edit");
const InfoSearchPatients = () => import("@/components/cms/infosearch/patients/patients");
const InfoSearchPatientsEdit = () => import("@/components/cms/infosearch/patients/patients-edit");
const InfoSearchCategory = () => import("@/components/cms/infosearch/category/category");
const InfoSearchCategoryEdit = () => import("@/components/cms/infosearch/category/category-edit");
const InfoSearchStatistics = () => import("@/components/cms/infosearch/statistics");

/*
  Modules
 */
const PreRegistration = () => import("@/components/cms/modules/preregistration/preregistration");
const MeetingRoomEdit = () => import("@/components/cms/modules/meetingRoom/meetingRoom-editCustomName");
const Meetings = () => import("@/components/cms/modules/meetingRoom/meetings");
const MeetingsLog = () => import("@/components/cms/modules/meetingRoom/meetingsLog");
const MeetingEmail = () => import("@/components/cms/modules/meetingRoom/meetingEmail");
const QueueSystemLines = () => import("@/components/cms/modules/queueSystem/lines/lines");
const QueueSystemLinesEdit = () => import("@/components/cms/modules/queueSystem/lines/lines-edit");
const QueueSystemLinesManage = () => import("@/components/cms/modules/queueSystem/lines/lines-manage");
const EnturLines = () => import("@/components/cms/modules/entur/lines");
const EnturLineEdit = () => import("@/components/cms/modules/entur/line-edit");
const PreRegisterMeetings = () => import("@/components/cms/preRegisterMeeting/preRegisterMeetings");
const PreRegisterMeetingEdit = () => import("@/components/cms/preRegisterMeeting/preRegisterMeetingEdit");
const PreRegisterMeetingStatus = () => import("@/components/cms/preRegisterMeeting/preRegisterMeetingStatus");
const Redirect = () => import("@/components/cms/common/redirect");
const VisitorsCustom = () => import("@/components/cms/modules/visitorsCustom/visitors-custom");

// added import for admin dashboard figures
const FigureDashboard = () => import("@/components/cms/dashboard/figure");

export const cmsComponents = {
  mainCms: () => import("@/components/cms/main/main"),
  CmsContent: () => import("@/components/cms/main/CmsContent"),
  NavigationPanel: () => import("@/components/cms/layout/navigation/panels/NavigationPanel"),
  Login: () => import("@/components/cms/login/login"),
  Sites: () => import("@/components/cms/sites/sites"),
  SitePages: () => import("@/components/cms/sites/editSite/sitePages/sitePages"),
  SitesNamedContent: () => import("@/components/cms/sites/namedContent/namedContent"),
  SitesNamedContentEdit: () => import("@/components/cms/sites/namedContent/namedContentEdit"),
  ActiveVisitors: ActiveVisitors,
  Companies: () => import("@/components/cms/admin/companies/companies"),
  CompaniesEdit: () => import("@/components/cms/admin/companies/companies-edit"),
  Kiosks: () => import("@/components/cms/admin/kiosks/kiosks"),
  Logger: () => import("@/components/cms/admin/logger/logger"),
  smsLogs: () => import("@/components/cms/admin/smsLogs/smsLogs"),
  AdminDepartments: AdminDepartments,
  AdminDepartmentsEdit: AdminDepartmentsEdit,
  JobDepartments: JobDepartments,
  Users: () => import("@/components/cms/admin/users/users"),
  UsersEdit: () => import("@/components/cms/admin/users/users-edit"),
  CompanyUsers: CompanyUsers,
  CompanyUsersEdit: CompanyUsersEdit,
  DropinUsers: DropinUsers,
  DropinUsersEdit: DropinUsersEdit,
  CompanyMessages: CompanyMessages,
  DropinMessages: DropinMessages,
  VisitorMessages: VisitorMessages,
  EvacuationMessages: EvacuationMessages,
  VisitexpressMessages: VisitexpressMessages,
  PreregistrationMessages: PreregistrationMessages,
  UserGroup: () => import("@/components/cms/admin/user-group/user-group"),
  UserGroupEdit: () => import("@/components/cms/admin/user-group/user-group-edit"),
  Statistics: Statistics,
  SiteSettings: SiteSettings,
  PreRegistration: PreRegistration,
  Meetings: Meetings,
  MeetingsLog: MeetingsLog,
  MeetingEmail: MeetingEmail,
  LangDictionary: LangDictionary,
  LangDictionaryEdit: LangDictionaryEdit,
  Versions: Versions,
  Tokens: Tokens,
  LoginPictureSettings: LoginPictureSettings,
  DashboardSlideshowSettings: DashboardSlideshowSettings,
  MeetingRoomEdit: MeetingRoomEdit,
  Editor: Editor,
  InfoSearchBase: InfoSearchBase,
  InfoSearchSites: InfoSearchSites,
  InfoSearchAreas: InfoSearchAreas,
  InfoSearchAreasEdit: InfoSearchAreasEdit,
  InfoSearchPatients: InfoSearchPatients,
  InfoSearchPatientsEdit: InfoSearchPatientsEdit,
  InfoSearchCategory: InfoSearchCategory,
  InfoSearchCategoryEdit: InfoSearchCategoryEdit,
  InfoSearchStatistics: InfoSearchStatistics,
  QueueSystemLines: QueueSystemLines,
  QueueSystemLinesEdit: QueueSystemLinesEdit,
  QueueSystemLinesManage: QueueSystemLinesManage,
  EnturLines: EnturLines,
  EnturLineEdit: EnturLineEdit,
  VisitExpress: () => import("@/components/cms/visitExpress/visitExpress"),
  PreRegisterMeetings: PreRegisterMeetings,
  PreRegisterMeetingEdit: PreRegisterMeetingEdit,
  PreRegisterMeetingStatus: PreRegisterMeetingStatus,
  Redirect: Redirect,
  VisitorsCustom: VisitorsCustom,
  MultiQueue: MultiQueue,
  CompanySettings: CompanySettings,
  FigureDashboard, // <-- registered so routes can reference it
};
